import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import directives from '../src/assets/js/directives';
import mammoth from 'mammoth';

import store from './store/';
import ElementUI from 'element-ui';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
// import echarts from 'echarts';

import * as echarts from 'echarts'; // 更换最新的echarts后改变引入
import 'element-ui/lib/theme-chalk/index.css';
import Meta from 'vue-meta';
import { Message } from 'element-ui';
// import '../public/UEditor/ueditor.config.js'
// import '../public/UEditor/ueditor.all.min.js'
// import '../public/UEditor/lang/zh-cn/zh-cn.js'
// import '../public/UEditor/ueditor.parse.js'
import filters from './filters';

import './assets/css/cssreset.css'; //css重置
import './assets/css/bootstrap.css';
import './assets/css/common.scss';
import './utils/permission'; //权限控制

// import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';

import './assets/css/quillEditor.scss';

import './icons'; // icons

import './componentReg/buttons'; // button组件引入

import './componentReg/eaArea'; // division组件引入
import './componentReg/page'; // page组件引入
import { preventReClick } from './utils/isCommitted';
import './directives/resize'; // resize引入
// import 'default-passive-events'; //浏览器冒泡？
import {
	removeUser,
	getToken,
	getUser,
	setUser,
	setToken,
} from '@/utils/auth.js';

import { MyWorkControllerSvr } from '@/service/MyWorkControllerSvr';
import PrintNB from 'vue-print-nb';
import Print from '@/plugs/print';
import { AuthenticationControllerSvr } from '@/service/AuthenticationControllerSvr.js';
import { SysConfigServiceSvr } from '@/service/SysConfigMge/SysConfigServiceSvr';
import moment from 'moment';

import GdCesiumMaplib from 'gd-cesium-maplib';
import 'gd-cesium-maplib/index.css';
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import GdCesiumMaplibBt from 'gd-cesium-maplib-bt';
import ZkbtZhwyjg from 'zkbt-zhwyjg';
import 'zkbt-zhwyjg/lib/zkbt-zhwyjg.css'; //物业监管
// import gdCesiumMaplib from 'gd-cesium-maplib'
// import 'gd-cesium-maplib/index.css'

// 拖拽指令
import Drag from './utils/drag';
Vue.use(GdCesiumMaplib);
Vue.use(GdCesiumMaplibBt);
Vue.use(Print);
Vue.use(ElementUI, { zhLocale });
Vue.use(echarts);
Vue.use(directives);
Vue.use(preventReClick);
Vue.use(Meta);
Vue.use(PrintNB);
Vue.use(ZkbtZhwyjg);
Vue.use(Drag);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
//修复element提交时间少8小时问题
Date.prototype.toISOString = function () {
	return moment(this).format('YYYY-MM-DD HH:mm:ss');
};

Object.keys(filters).forEach((k) => Vue.filter(k, filters[k]));
// Vue.component('vue-ueditor-wrap', VueUeditorWrap)//编辑器
//系统改造弹窗注释
sessionStorage.setItem('tipDialogVisible', JSON.stringify('false'));
// 根据深圳需求跳转至不同的登录页面
function getSystemConfig(next) {
	new SysConfigServiceSvr()
		.getSystemConfig('redirect2SSOURL')
		.then((res) => {
			if (res === null || res === '' || !res.redirect2SSOURL) {
				return next('/wscsdl');
				// getSystemConfig(next('login'));
			} else {
				return (window.location.href = res.redirect2SSOURL);
			}
		})
		.catch((err) => {
			Message.error({
				message: err.Msg,
			});
		});
}

let routerbefp = (to, from, next) => {
	if (to.query.__sk_keysn && to.query.__sk_keyid) {
		new AuthenticationControllerSvr()
			.SimpleLogin(to.query.__sk_keysn, to.query.__sk_keyid)
			.then((res) => {
				setToken(res);
				store.commit('SET_TOKEN', res);
				store.dispatch('GetUserInfo').then((res) => {
					store
						.dispatch('GetUserRoleInfo')
						.then((roleRes) => {
							next('/index');
						})
						.catch((err) => {
							Message.error({
								message: err,
								duration: 1500,
							});
						});
				});
			})
			.catch((err) => {
				Message.error({
					message: '登录失效',
				});
				next('login');
			});
	} else {
		let pathlist = [
			'wscsdl',
			'500',
			'externalLink',
			'firstEntry',
			'orgRankState',
			'externalLinks',
			'ownerEvaluationLists',
			'PropertyProjectList',
			'DetailedCellRanking',
			'OwnerCertificate',
			'PropertyProjectInformationInquiryList',
			'PropertyProjectInformationDetailList',
			'EmployeeInformationInquiryList',
			'PropertyProjectManagerDetails',
			'InformationInquiryPropertyEnterprisesList',
			'InformationDetailPropertyEnterprisesList',
			'InformationCompany',
			'InformationManager',
			'creditInformationDetail',
			'comprehensiveList',
			'evaluateDetail',
			'overallEvaluation',
			'comprehensiveDetailsList',
			'GeneralMeetingOfProprietorsList',
			'GeneralMeetingOfProprietorsDetailList',
			'officialWebsiteList',
			'evaluationSituationDetail',
			'companyBaseDetail',
			'officialCompanyBaseInfoDetailPenetrate',
			'officialManagerBaseInfoDetail',
			'officialManagerBaseInfoDetailPenetrate',
			'officialGoodInfoDetail',
			'officialBadInfoDetail',
			'officialRiskInfoDetail',
			'finished',
		];
		let flag = 0;
		pathlist.forEach((s) => {
			if (to.path === '/' + s) {
				flag = 1;
			}
		});
		//只要数组中的地址与to.path有一个相同，则直接进入，不需要跳转到省统一平台
		if (flag == 1) {
			next();
		} else {
			if (router.history.pending.query.token) {
				store.commit('SET_TOKEN', router.history.pending.query.token);
				setToken(router.history.pending.query.token);
				return next('/index');
			} else if (getToken()) {
				if (!store.getters.userInfo.UserParam) {
					store.commit('SET_TOKEN', getToken());
					store
						.dispatch('GetUserInfo')
						.then((res) => {
							let right = '';
							store
								.dispatch('GetUserRoleInfo')
								.then((roleRes) => {
									store
										.dispatch('GenerateRoutes', {
											right,
										})
										.then(() => {
											router.addRoutes(
												store.state.addRouters,
											);
											next({
												...to,
												replace: true,
											}); // hack方法
										})
										.catch((err) => {
											removeUser();
											this.$store.commit(
												'SET_TOKEN',
												null,
											);
											this.$store.commit(
												'SET_USERINFO',
												null,
											);
											Message.error({
												message: err,
												duration: 1500,
											});
										});
								})
								.catch((err) => {
									Message.error({
										message: err,
										duration: 1500,
									});
								});
						})
						.catch((err) => {
							removeUser();
							this.$store.commit('SET_TOKEN', null);
							this.$store.commit('SET_USERINFO', null);
							Message.error({
								message: '登录失效',
							});
							router.push('login');
							//getSystemConfig(next);//登录失效回到深圳系统登录
							// window.location.href='http://192.168.100.166/wxjsys/commonlogin/transfer.do?from=szwyweb';
							// next();
							// next('login');
						});
				} else {
					if (to.meta.workflow === true) {
						new MyWorkControllerSvr()
							.startWork(getToken(), to.meta.workTemplateName)
							.then((res) => {
								if (res.WorkName === '安全检查') {
									next({
										path:
											'/' +
											JSON.parse(res.ActionPara).Url1,
										query: {
											workId: res.WorkID,
											taskName: res.TaskName,
											type: '1',
										},
									});
								} else if (res.WorkName === '专项检查') {
									next({
										path:
											'/' +
											JSON.parse(res.ActionPara).Url1,
										query: {
											workId: res.WorkID,
											taskName: res.TaskName,
											type: '2',
										},
									});
								} else {
									next({
										path:
											'/' +
											JSON.parse(res.ActionPara).Url1,
										query: {
											workId: res.WorkID,
											taskName: res.TaskName,
										},
									});
								}
							});
					} else {
						next();
					}
				}
			} else {
				if (router.history.pending.query.token) {
					store.commit(
						'SET_TOKEN',
						router.history.pending.query.token,
					);
					setToken(router.history.pending.query.token);
					return next('/index');
				} else {
					getSystemConfig(next); // 否则全部重定向到登录页
				}
			}
		}
	}
};

router.beforeEach(routerbefp);

window.Vue = new Vue({
	router,
	store,
	render: (h) => h(App),
	beforeCreate() {
		Vue.prototype.$bus = this; //安装全局事件总线
	},
}).$mount('#app');
